module.exports = __webpack_public_path__ + "static/media/googleLogo.07573878.svg";